// Analytics consent, stored client-side and keyed per user (Cognito sub) so the
// choice is single-per-person: it survives logout and workspace switches, and a
// different user is asked separately. Value is "granted" | "denied".
const CONSENT_PREFIX = "bf_analytics_consent:";

export function consentKey(userId) {
  return `${CONSENT_PREFIX}${userId}`;
}

export function getStoredConsent(userId) {
  if (!userId) return null;
  try {
    return localStorage.getItem(consentKey(userId));
  } catch {
    return null;
  }
}

export function setStoredConsent(userId, value) {
  if (!userId) return;
  try {
    localStorage.setItem(consentKey(userId), value);
  } catch {
    /* ignore (private mode / storage disabled) */
  }
}

/**
 * Clear app storage on logout WITHOUT discarding consent decisions, so the same
 * user is not re-prompted on the next login (consent is single-per-person).
 */
export function clearStorageKeepingConsent() {
  try {
    const preserved = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key && key.startsWith(CONSENT_PREFIX)) {
        preserved.push([key, localStorage.getItem(key)]);
      }
    }
    localStorage.clear();
    preserved.forEach(([key, value]) => localStorage.setItem(key, value));
  } catch {
    /* ignore */
  }
}
